import { ReactNode } from 'react';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';
import MouseScroll from '../icon/components/mouse-scroll';

import styles from './scrollable-content-indicator.module.scss';

export type IconPosition =
  | 'bottomRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'topRight'
  | 'topLeft'
  | 'topCenter';

type Props = {
  children: (arg1: (node?: Element | null) => void) => ReactNode;
  iconPosition?: IconPosition;
  disabled?: boolean;
  triggerOnce?: boolean;
};

const ScrollableContentIndicator = ({
  children,
  iconPosition = 'bottomRight',
  disabled = false,
  triggerOnce = false,
}: Props) => {
  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce,
  });

  return (
    <div className={styles.wrapper}>
      {children(ref)}
      {!disabled && !inView && (
        <MouseScroll
          className={classNames(
            styles[`icon-position`],
            styles[`icon-position--${iconPosition}`],
            styles[`scrolling-animation`],
          )}
        />
      )}
    </div>
  );
};

export default ScrollableContentIndicator;
